import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSelector.css';

const LanguageSelector = () => {
  const { i18n, t } = useTranslation();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const languages = [
    { code: 'en', name: t('languages.en') }, //English
    { code: 'te', name: t('languages.te') }, //Telugu
    { code: 'or', name: t('languages.or') }, //Oriya
    { code: 'kn', name: t('languages.kn') },  //Kannada 
    { code: 'ml', name: t('languages.ml') },  //Malayalam
    { code: 'bn', name: t('languages.bn') },  //Bengali
    { code: 'mr', name: t('languages.mr') }, //Marathi
    { code: 'gu', name: t('languages.gu') }, //Gujarati
    { code: 'ta', name: t('languages.ta') }, //Tamil
    { code: 'hi', name: t('languages.hi') }, //Hindi  
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    setShowDropdown(false);
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div
      ref={dropdownRef}
      className="language-selector"
        style={{ position: 'relative' }}
    >
      <div
        onClick={toggleDropdown}
        className="language-selector-button"
      >
        <span>{currentLanguage.name}</span>
        <span>    ▼</span>
      </div>

      {showDropdown && (
        <div className="language-dropdown">
          {languages.map((lang) => (
            <div
              key={lang.code}
              className={`language-option ${i18n.language === lang.code ? 'selected' : ''}`}
              onClick={() => changeLanguage(lang.code)}
            >
              {lang.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;